// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:06:28

export default {
  "id": "battle-of-pirate-caribbean-battle",
  "slug": "battle-of-pirate-caribbean-battle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3f3b97e87f7a42ce8a39d256866269ce-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3f3b97e87f7a42ce8a39d256866269ce/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Battle of Pirate Caribbean Battle",
      "description": "Battle of Pirate: Caribbean Battle is an action-packed war game where you command a mighty pirate ship and engage in thrilling naval battles! Prepare for an epic battle war game as you sail through the Caribbean seas, fighting rival pirates, enemy warships, and legendary sea monsters. Use powerful cannons, guns, and strategic combat to conquer the ocean and become the ultimate pirate captain!\n\n",
      "instructions": "Mouse Control Your JoyStick For Player Ship Movements\nKeyboard Space Button For Using Fire  ",
      "genres": [
        "Battle",
        "Shooter"
      ],
      "tags": [
        "battleship",
        "ocean",
        "ship",
        "war"
      ]
    },
    "zh-CN": {
      "title": "海盗加勒比海之战",
      "description": "《海盗之战：加勒比海战》是一款充满动作的战争游戏，你将指挥一艘强大的海盗船，参与刺激的海战！准备体验一场史诗般的战争游戏，在加勒比海上航行，与敌对海盗、敌军战舰和传奇海洋生物作战。使用强大的大炮、枪械和战略战斗征服海洋，成为终极海盗船长！",
      "instructions": "鼠标控制摇杆进行玩家飞船移动\n键盘空格键用于使用射击",
      "genres": [
        "战斗",
        "射击"
      ],
      "tags": [
        "战舰",
        "海洋",
        "船只",
        "战争"
      ]
    },
    "zh-TW": {
      "title": "海盜加勒比海戰役",
      "description": "海盜戰爭：加勒比海戰役是一款充滿動作的戰爭遊戲，在遊戲中您將指揮一艘強大的海盜船，進行刺激的海戰！準備進行一場宏偉的戰爭遊戲，您將航行於加勒比海，與敵對的海盜、敵軍戰艦和傳說中的海怪作戰。使用強大的大炮、槍械和戰術作戰征服海洋，成為最終的海盜船長！",
      "instructions": "滑鼠控制摇杆以操作玩家船隊移動\n按鍵空格鍵使用射擊",
      "genres": [
        "戰鬥",
        "射擊"
      ],
      "tags": [
        "戰艦",
        "海洋",
        "船",
        "戰爭"
      ]
    },
    "zh-HK": {
      "title": "海盜加勒比海戰役",
      "description": "海盜戰爭：加勒比海戰役是一款充滿動作的戰爭遊戲，您將指揮一艘強大的海盜船，參與刺激的海上戰鬥！準備進行一場經典的戰爭遊戲，您將航行於加勒比海，與敵對的海盜、敵方戰艦和傳說中的海怪作戰。使用強大的大炮、槍械和戰術作戰征服海洋，成為最終的海盜船長！",
      "instructions": "滑鼠控制搖桿用於玩家船隊移動\n按鍵空格鍵用於使用火炮",
      "genres": [
        "戰鬥",
        "射擊"
      ],
      "tags": [
        "戰艦",
        "海洋",
        "船",
        "戰爭"
      ]
    },
    "ja": {
      "title": "パイレットのカリブ海戦争",
      "description": "バトル・オブ・パイレート：カリブ海の戦いは、巨大な海賊船を指揮し、刺激的な海戦に参加するアクション満載の戦争ゲームです！カリブ海を航海しながら、ライバルの海賊、敵の戦艦、そして伝説の海怪物と戦う壮大な戦争ゲームに備えましょう。強力な大砲、銃、戦略的な戦闘を駆使して海を征服し、最強の海賊船長に昇華せよ！",
      "instructions": "マウスでJoyStickを操作してプレイヤーシップの移動\nキーボードのスペースボタンで発射を使用",
      "genres": [
        "バトル",
        "シューティング"
      ],
      "tags": [
        "戦艦",
        "海",
        "船",
        "戦争"
      ]
    },
    "ko": {
      "title": "해적 카리브해 전쟁",
      "description": "배적전: 카리브해 전쟁은 강력한 해적선을 지휘하여 흥미진진한 해전을 펼치는 액션 가득한 전쟁 게임입니다! 카리브해를 항해하며 상대 해적, 적함대, 전설적인 해양몬스터와 싸우는 약소 전쟁 게임을 준비하세요! 강력한 캐논, 포, 전략적 전투를 사용하여 바다를 정복하고 최종 해적 캡틴이 되세요!",
      "instructions": "마우스 컨트롤을 통해 조이스틱으로 플레이어의선함을 이동시키세요\n키보드 공백키를 통해 발사 사용",
      "genres": [
        "전투",
        "총알게임"
      ],
      "tags": [
        "전함",
        "바다",
        "배",
        "전쟁"
      ]
    },
    "fr": {
      "title": "Bataille des Pirates des Caraïbes",
      "description": "Bataille de Pirate : Bataille des Caraïbes est un jeu de guerre haletant où vous commandez un vaisseau pirate puissant et engagez-vous dans des batailles navales captivantes ! Préparez-vous à un jeu de guerre épique alors que vous naviguez à travers les mers des Caraïbes, combattant des pirates rivaux, des navires de guerre ennemis et des monstres marins légendaires. Utilisez des canons puissants, des armes à feu et des combats stratégiques pour conquérir l'océan et devenir le capitaine pirate ultime !",
      "instructions": "Contrôle souris pour les mouvements du vaisseau du joueur\nTouche Espace de la键盘 pour utiliser le feu",
      "genres": [
        "Bataille",
        "tireur d'élite"
      ],
      "tags": [
        "battleship",
        "océan",
        "navire",
        "guerre"
      ]
    }
  }
};
